import cx from 'classnames';
import Cookies from 'js-cookie';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';

import Button from '../../../ui/button';
import BPImage from '../../../ui/image';
import BPModal from '../../../ui/modal';
import IconShield from '../../../ui/icons/shield';

const EuropeAssitanceBanner = () => {
  const [showEurop, setShowEurop] = useState(false); // added while viewing product
  const [showEuropModal, setShowEuropModal] = useState(false); // added while viewing product
  const { t } = useTranslation();
  const isUkWebsite = process.env.NEXT_PUBLIC_HOST?.includes('.co.uk');

  useEffect(() => {
    setShowEurop(Cookies.get('europ_banner') ? false : true);
  }, []);

  if (!showEurop) return null;

  return (
    <>
      <div className={cx('bg-blue-5 p-4')}>
        <div
          className={cx(
            'container mx-auto bg-blue-5 flex flex-row gap-4 items-center justify-center'
          )}
        >
          <IconShield className="w-4 h-4 max-lg:w-12 max-lg:h-12 text-blue-110" />
          <span>
            <Trans
              i18nKey={isUkWebsite ? "product:europ_banner.text_uk" : "product:europ_banner.text"}
              components={{
                b: <b />,
              }}
            />
            <button
              className={cx('focus:outline-none')}
              onClick={() => setShowEuropModal(true)}
            >
              <a className={cx('underline', 'ml-2', 'font-bold')}>
                {t('product:europ_banner.link')}
              </a>
            </button>
          </span>
          <div className={cx('')}>
            <Button
              isFullWidth={false}
              variant="NO-HOVER"
              disableHeight={true}
              className="flex items-center justify-center"
              onClick={() => {
                Cookies.set('europ_banner', 'closed', { expires: 365 });
                setShowEurop(false);
              }}
            >
              <BPImage
                src={`${process.env.PUBLIC_PREFIX}/svg/icons/close.svg`}
                width={16}
                height={16}
              />
            </Button>
          </div>
        </div>
      </div>
      {showEuropModal && (
        <BPModal
          variant="alert"
          isOpen={true}
          onRequestClose={() => setShowEuropModal(false)}
          title={t('common:extra-info')}
          titleVariant="left"
        >
          <Trans
            key={isUkWebsite ? "product:europ_modal_uk" : "product:europ_modal"}
            i18nKey={isUkWebsite ? "product:europ_modal_uk" : "product:europ_modal"}
            components={{ b: <b /> }}
          />
        </BPModal>
      )}
    </>
  );
};

export default EuropeAssitanceBanner;
